/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateNewTeamTransferTokenCommandRequest } from '../models/CreateNewTeamTransferTokenCommandRequest';
import type { CreateNewTeamTransferTokenCommandResponse } from '../models/CreateNewTeamTransferTokenCommandResponse';
import type { DeactivateTeamTransferTokenCommandRequest } from '../models/DeactivateTeamTransferTokenCommandRequest';
import type { DeactivateTeamTransferTokenCommandResponse } from '../models/DeactivateTeamTransferTokenCommandResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class TeamTransferTokensApiService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param requestBody
     * @returns CreateNewTeamTransferTokenCommandResponse OK
     * @throws ApiError
     */
    public postApiV10TeamTransferTokens(
        requestBody?: CreateNewTeamTransferTokenCommandRequest,
    ): Observable<CreateNewTeamTransferTokenCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/TeamTransferTokens',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DeactivateTeamTransferTokenCommandResponse OK
     * @throws ApiError
     */
    public putApiV10TeamTransferTokensDeactivate(
        requestBody?: DeactivateTeamTransferTokenCommandRequest,
    ): Observable<DeactivateTeamTransferTokenCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v1.0/TeamTransferTokens/Deactivate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
}
